import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import { IPricingCard } from 'src/hooks/usePricingCards';
import CheckItemText from '../CheckItemText/CheckItemText';

type KeyFeaturesProps = Pick<IPricingCard, 'keyFeatures'>;

const KeyFeatures = ({ keyFeatures }: KeyFeaturesProps): JSX.Element => (
  <Grid padding={['spacing-4xl', 'spacing-4xl', 'spacing-5xl', 'spacing-4xl']}>
    <Stack
      direction='column'
      gap='spacing-3xl'
      justify='center'
      align='flex-start'
    >
      <Typography
        type='paragraph'
        size='md'
        fontWeight='font-weight-semibold'
        textAlign='left'
      >
        KEY FEATURES
      </Typography>
      <Stack
        direction='column'
        justify='center'
        align='flex-start'
        gap='spacing-xl'
      >
        {keyFeatures.map((feature) => (
          <CheckItemText
            key={feature}
            text={feature}
            size='sm'
            type='line'
            color='success'
          />
        ))}
      </Stack>
    </Stack>
  </Grid>
);

export default KeyFeatures;
